import { storage } from '@/utils/storage'

export default {
	namespaced: true,

	state: {
		screen: {
			width: 177*.5,
			height: 100*.5,
			x: 502,
      y: 30,
      z: -245
		},
		letterLegends: [
      {
        position: { x: 0, y: 0, z: 0 },
        transform: { x: -1, y: 0, z: 0 },
        url: '/images/legends/0.png',
        index: 0
      },
      {
        position: {
          x: 0,
          y: 0,
          z: 0
        },
        transform: { x: -1, y: -1, z: 0 },
        url: '/images/legends/1.png',
        index: 1
      },
      {
        position: {
          x: 0,
          y: 0,
          z: 0
        },
        transform: { x: 0, y:   0, z: 0 },
        url: '/images/legends/5.png',
        index: 5
      }
    ],
    popinsSeen: []
	},

  getters: {
    popinsSeen: state => {
      return state.popinsSeen
    }
  },

  actions: {
    popinsSeen ({ commit, state }) {
      return new Promise(resolve => {
        storage.getItem('popinsSeen').then(res => {
          if (res !== null) {
            commit('popinsSeen', res)
          }
          resolve()
        })
      })
    },
    setPopinsSeen ({ commit, state }, slug) {
      storage.setItem('popinsSeen', [...state.popinsSeen, slug])
      commit('popinsSeen', [...state.popinsSeen, slug])
    }
  },

  mutations: {
    popinsSeen (state, payload) {
      state.popinsSeen = payload
    }
  }
}